import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import type { CmsSlotsList } from '../../utils/amplience/types';
import type { CmsSlotsContextProps } from './CmsSlotsContextType';
import { CmsSlotsContext } from './cmsSlotsContext';

export function CmsSlotsProvider({
  children,
  cmsSlotsData = {} as CmsSlotsList,
}: PropsWithChildren<CmsSlotsContextProps>) {
  const [contextData, setContextData] = useState<CmsSlotsList>(cmsSlotsData);

  useEffect(() => {
    setContextData(cmsSlotsData);
  }, [cmsSlotsData]);

  return <CmsSlotsContext.Provider value={contextData}>{children}</CmsSlotsContext.Provider>;
}
